/**
 * Date formatting utility functions
 */

/**
 * Format a UTC date string to mmm dd, yyyy HH:mm format
 * 
 * @param utcDateString - The UTC date string to format
 * @returns Formatted date string in mmm dd, yyyy HH:mm format (e.g., "Jan 19, 2025 14:30")
 */
export const formatLastModified = (utcDateString: string): string => {
  if (!utcDateString) return '';
  
  try {
    const date = new Date(utcDateString);
    
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return utcDateString; // Return original string if invalid
    }
    
    // Array of 3-letter month abbreviations
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    
    // Format to mmm dd, yyyy HH:mm
    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${month} ${day}, ${year} ${hours}:${minutes}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return utcDateString; // Return original string if error occurs
  }
};
